import { ServiceResponse } from "../ServiceResponse";

export class SendVerifyEmailResponse extends ServiceResponse
{
  public sendEmailSuccess: boolean = false;
  public userExists: boolean = false;
}
